import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FacultySearchResponseModel } from '../../shared/models/data/faculty-search-response-model';
import { FacultySearchModel } from '../../shared/models/data/faculty-search-model';


@Component({
  selector: 'aaos-faculty-search-result-dialog',
  templateUrl: './faculty-search-result-dialog.component.html',
  styleUrls: ['./faculty-search-result-dialog.component.scss']
})
export class FacultySearchResultDialogComponent implements OnInit {

  facultyMember: FacultySearchModel;
  newFacultyMember: FacultySearchModel;
  @Output() actionTaken: EventEmitter<FacultySearchModel> = new EventEmitter<FacultySearchModel>();

  constructor(@Inject(MAT_DIALOG_DATA) public results: FacultySearchResponseModel,
              public dialogRef: MatDialogRef<FacultySearchResultDialogComponent>) { }

  ngOnInit(): void {
    this.newFacultyMember = new FacultySearchModel();
  }

  addFaculty() {
        this.actionTaken.next(this.facultyMember);
        this.dialogRef.close();
  }

}
